.container {
  display: flex;
  flex-wrap: wrap;
}

.avatar {
  margin: 8px;
}
